<template>
  <div>
    <!-- Drawer for mobile navigation -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      hide-on-sm-and-down
    >
      <v-toolbar-title class="pa-4 text-center d-flex flex-column align-center">
        <img src="../assets/images/live_stream_logo.png" alt="" width="100%"> <br>
        Rizal Live Streaming
      </v-toolbar-title>

      <v-list>
        <v-list-item :to="'/'">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item :to="'/highlights'">
          <v-list-item-title>Highlights</v-list-item-title>
        </v-list-item>
        <v-list-item :to="'/live'">
          <v-list-item-title class="live-style">Watch Live</v-list-item-title>
        </v-list-item>
        <v-list-item :to="'/newsAndEvents'">
          <v-list-item-title>News and Events</v-list-item-title>
        </v-list-item>
        <v-list-item :to="'/contactUs'">
          <v-list-item-title>Contact Us</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- App bar with navigation -->
    <v-app-bar
      dense
      dark
      class="nav-style"
      fixed
    >
      <!-- Menu icon to open the drawer on mobile -->
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>Rizal Live Streaming</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Navigation Buttons for desktop -->
      <v-btn text class="hide-nav" :to="'/'">Home</v-btn>
      <v-btn text class="hide-nav" :to="'/highlights'">Highlights</v-btn>
      <v-btn text class="hide-nav" :to="'/newsAndEvents'">News and Events</v-btn>
      <v-btn text class="hide-nav" :to="'/contactUs'">Contact Us</v-btn>

      <v-spacer></v-spacer>
      <router-link to="/live" class="highlight-btn hide-nav">
        WATCH LIVE NOW
      </router-link>
    </v-app-bar>
    <div class="nav-wall"></div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      drawer: false, // Controls mobile drawer
      menuItems: [
        { label: "HOME", route: "/" },
        { label: "News And Events", route: "/newsAndEvents" },
        { label: "Contact Us", route: "/contactUs" },
      ],
    };
  },
  methods: {
    closeDrawer() {
      this.drawer = false; // Close drawer when a link is clicked
    },
  },
};
</script>

<style scoped>
.highlight-btn {
  background-color: red;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  padding: 10px 15px;
  text-decoration: none;
  border-radius: 5px;
}

.hide-nav {
  visibility: visible;
}

.live-style {
  color: red;
  font-weight: bold;
}

.nav-style {
  background-color: rgba(0, 0, 0, 0.5) !important; /* Black with 50% transparency */
}

.nav-wall {
  padding-bottom:48px;
  background-color: rgb(25, 25, 25)
}

@media (max-width: 817px) {
  .hide-nav {
    visibility: hidden;
    display: none;
  }

}

</style>
